<template>
  <div class="economic-performancekey-words-container">
    <span class="card-title">Palavras-chave em alta em avaliações</span>
    <div class="economic-performancekey-words-container-block-pills">
      <CustomSkeleton v-if="isLoadingAllData" type="card" />
      <div v-if="!isLoadingAllData">
        <div
          v-for="(keyword, index) in keyWords.negative_keywords"
          :key="index + 'negative_keywords'"
          style="background-color: #ff6666"
          class="economic-performancekey-pill"
          :title="keyword[1] + ' Impressões'"
        >
          {{ keyword[0] }}
        </div>
        <div
          v-for="(keyword, index) in keyWords.neutral_keywords"
          :key="index + 'neutral_keywords'"
          style="background-color: #ffd700"
          class="economic-performancekey-pill"
          :title="keyword[1] + ' Impressões'"
        >
          {{ keyword[0] }}
        </div>
        <div
          v-for="(keyword, index) in keyWords.positive_keywords"
          :key="index + 'positive_keywords'"
          style="background-color: #008000"
          class="economic-performancekey-pill"
          :title="keyword[1] + ' Impressões'"
        >
          {{ keyword[0] }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomSkeleton from '@/Shared/CustomSkeleton.vue'

export default {
  name: 'Keywords',
  components: {
    CustomSkeleton,
  },
  props: {
    keyWords: {
      type: Object,
      required: true,
    },
    isLoadingAllData: {
      type: Boolean,
      required: true,
    },
  },
}
</script>

<style src="./styles.css"></style>
